import { useState, useEffect, RefObject } from 'react';

export const useContainerHeight = (ref: RefObject<HTMLElement>) => {
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setContainerHeight(entry.contentRect.height);
      }
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return containerHeight;
};
